import TodoList from 'components/Todos/TodoList'

import EnrollmentTracker from './EnrollmentTracker/EnrollmentTracker'
import UpcomingImportantDates from './ImportantDates/UpcomingImportantDates'
import { LastMonthCost } from './LastMonthCosts/LastMonthCost'
import ReportsCard from './Reports/ReportsCard'

export default function EmployerHomePage () {
  return (
    <div className='flex flex-col -mb-[75px]'>
      <div className='flex items-center justify-between pb-6 border-b border-gray-200'>
        <h1 className='heading-lg'>Home</h1>
      </div>

      <div className='py-10'>
        <TodoList
          category={['onboarding', 'general']}
          title='Welcome to Thatch!'
        />
      </div>

      <div className='flex gap-10 items-stretch border-t border-gray-200'>
        <div className='flex-1 py-10 flex flex-col'>
          <EnrollmentTracker />
        </div>
        <div className='w-px bg-gray-200' />
        <div className='flex-1 py-10 flex flex-col'>
          <UpcomingImportantDates />
        </div>
      </div>

      <div className='flex gap-10 items-start border-t border-gray-200'>
        <div className='flex-1 py-10'>
          <LastMonthCost />
        </div>
        <div className='w-px bg-gray-200 self-stretch' />
        <div className='flex-1 py-10'>
          <ReportsCard />
        </div>
      </div>
    </div>
  )
}
